import { createRef, useEffect, useState, useRef } from "react";
import cti3LogoWhite from "../assets/images/CTi3ColorLogo-NoBackground.png";
import loadable from "@loadable/component";
import { JWT_TOKEN } from "@cti-workspace/helpers";

// import VerifyFrame from "../verify/VerifyFrame";
import { API_URL, APP_URL, getApi, getObjectValue, JSONParse, transformOldToNewCredResp, useWindowDimensions } from "@cti-workspace/helpers";
import "@fontsource/plus-jakarta-sans";
import "@fontsource/lato";
import "@fontsource/source-sans-pro";
import "@fontsource/roboto";
import { Button } from "@cti-workspace/ui";
import queryString from "query-string";
import { SnackbarProvider } from "notistack";
import CloseIcon from "@material-ui/icons/Close";
import { Footer, Header, HeaderContainer, HeaderLogo, HeaderSubContainer, PrimaryContent, SecondaryContent, SpinnerBox, SubFooter1, VerifierBody } from "./VerifierPageComponents/Layout";
import { FooterButtonGroup, HeaderButtonGroup, LinkButton } from "./VerifierPageComponents/Button";
import Spinner from "./VerifierPageComponents/Spinner";
import CertContentRight from "./VerifierPageComponents/AdditionalContent";
// import MainContent from "./VerifierPageComponents/MainContent";
import ErrorPage from "./VerifierPageComponents/ErrorPage";
import cti3Logo from "../assets/images/CTi3_Black_logo-no_background.png";
import ipwruLogo from "../assets/images/iPWRU_Logo_Med.png";
import certificate_background from "../assets/images/certificate_background.png";

const MainContent = loadable(() => import("./VerifierPageComponents/MainContent"));

const defaultTheme = Object.freeze({
	primaryColor: "#009198",
	primaryColorOpacity: 1,
	secondaryColor: "#fafafa",
	secondaryColorOpacity: 1,
	fontColor1: "#000",
	fontColor1Opacity: 0.87,
	fontColor2: "#000",
	fontColor2Opacity: 0.54,
});

export default function App() {
	const [requestedDoc, setRequestedDoc] = useState(null);
	const [certState, setCertState] = useState("loading");
	// states loading, error, valid
	const [whitelabel, setWhitelabel] = useState(undefined);
	const [additionalDataMain, setAdditionalDataMain] = useState({});
	const [printPageSize, setPrintPageSize] = useState({ type: "", size: "landscape", pageType: "letter" });
	const [parsedDoc, setParsedDoc] = useState({});
	const [creExpired, setCreExpired] = useState(false);
	const [preview, setPreview] = useState(false);
	const [showContainer, setShowContainer] = useState(false);
	const [verifierTheme, setVerifierTheme] = useState(defaultTheme);
	const [renderConfig, setRenderConfig] = useState(null);
	const [verification, setVerification] = useState(null);
	const [usedNewApi, setUsedNewApi] = useState(false);
	const loc = window.location;
	const { host } = loc;

	const { id, dbl, document } = queryString.parse(loc.search);

	const { width } = useWindowDimensions();
	const isSmallDevice = width <= 700 ? true : false;

	const notistackRef = createRef();
	const onClickDismiss = (key) => () => {
		notistackRef.current.closeSnackbar(key);
	};
  const fallbackBackgroundImgRef = useRef(certificate_background);

	useEffect(() => {
		(async () => {
			if (id) {
				try {
					let data;
					let isNew;
					let isV2Api;

					try {
						data = await getApi(`/public/v2/cert/${id}?dbl=${dbl || "to"}`, {}, false, API_URL);
						isV2Api = true;
						if (data?.rendererConfig) {
							isNew = true;
						}
					} catch (err) {
						data = await getApi(`/public/cert/${id}?dbl=${dbl || "to"}`, {}, false, API_URL);
						isNew = false;
						isV2Api = false;
					}

					let {
						certificate,
						state,
						settings: { whitelabel, transcriptWatermark, verifierConfiguration },
						additionalData = {},
						verification,
            rendererConfig,
            backgroundImg,
					} = data;
					// console.log("whitelabel", whitelabel);
					// console.log("verifierConfiguration", verifierConfiguration);
					setWhitelabel(whitelabel);
					// console.log(state);
					if (state === "confirmed") setCertState("valid");
					if (state === "revoked") setCertState("revoked");
					//
					if (verifierConfiguration?.theme) {
						let val = verifierConfiguration.theme.default ? verifierConfiguration.theme.default : verifierConfiguration.theme;
						const verifierTheme = { ...defaultTheme, ...val };
						setVerifierTheme(verifierTheme);
					}
					// console.log(theme);
					setAdditionalDataMain({ ...additionalData, settings: { transcriptWatermark, verifierConfiguration } });

					let doc = isNew || isV2Api ? { value: certificate } : JSONParse(certificate);
					if (doc.value) {
						setRequestedDoc(doc.value);
						if (!doc.value.vc) {
							doc.value = transformOldToNewCredResp(doc.value);
						}

						setParsedDoc(doc.value.vc);
						if (doc?.value?.vc?.expirationDate) {
							var expiredOn = doc.value.vc.expirationDate.match(/(\d{1,4}([.\-/])\d{1,2}([.\-/])\d{1,4})/g);
							let givenDate = new Date(expiredOn[0]);
							let diff = new Date().getTime() - givenDate.getTime();
							if (diff > 0) {
								setCreExpired(true);
							}
						}
					} else {
						console.error(doc.error);
						setRequestedDoc(certificate);
						setCertState("error");
					}
					if (isNew) {
						setVerification(verification);
						setRenderConfig(rendererConfig);
            setUsedNewApi(true);
            if (backgroundImg && backgroundImg.includes("https://s3.ca-central-1.amazonaws.com") === false ) {
              fallbackBackgroundImgRef.current = backgroundImg;
            }
					}
				} catch (err) {
					setCertState("error");
					console.error(err);
				}
			} else {
				let parsedJSON = JSONParse(document);

				if (parsedJSON.value) {
					setParsedDoc(parsedJSON.value);
					setRequestedDoc(parsedJSON.value);

					setAdditionalDataMain(parsedJSON.value.additionalData);
					setCertState("valid");
					setPreview(true);
				} else {
					setCertState("error");
					console.error(parsedJSON.error);
				}
			}

			var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

			if (!isSafari) {
				const fontCheck = new Set(
					[
						// Windows 10
						"Arial",
						"Arial Black",
						"Bahnschrift",
						"Calibri",
						"Cambria",
						"Cambria Math",
						"Candara",
						"Comic Sans MS",
						"Consolas",
						"THAMMASAT Regular",
						"Constantia",
						"Corbel",
						"Courier New",
						"Ebrima",
						"Franklin Gothic Medium",
						"Gabriola",
						"Gadugi",
						"Georgia",
						"HoloLens MDL2 Assets",
						"Impact",
						"Ink Free",
						"Javanese Text",
						"Leelawadee UI",
						"Lucida Console",
						"Lucida Sans Unicode",
						"Malgun Gothic",
						"Marlett",
						"Microsoft Himalaya",
						"Microsoft JhengHei",
						"Microsoft New Tai Lue",
						"Microsoft PhagsPa",
						"Microsoft Sans Serif",
						"Microsoft Tai Le",
						"Microsoft YaHei",
						"Microsoft Yi Baiti",
						"MingLiU-ExtB",
						"Mongolian Baiti",
						"MS Gothic",
						"MV Boli",
						"Myanmar Text",
						"Nirmala UI",
						"Palatino Linotype",
						"Segoe MDL2 Assets",
						"Segoe Print",
						"Segoe Script",
						"Segoe UI",
						"Segoe UI Historic",
						"Segoe UI Emoji",
						"Segoe UI Symbol",
						"SimSun",
						"Sitka",
						"Sylfaen",
						"Symbol",
						"Tahoma",
						"Times New Roman",
						"Trebuchet MS",
						"Verdana",
						"Webdings",
						"Wingdings",
						"Yu Gothic",
						// macOS
						"American Typewriter",
						"Andale Mono",
						"Arial",
						"Arial Black",
						"Arial Narrow",
						"Arial Rounded MT Bold",
						"Arial Unicode MS",
						"THAMMASAT Regular",
						"Avenir",
						"Avenir Next",
						"Avenir Next Condensed",
						"Baskerville",
						"Big Caslon",
						"Bodoni 72",
						"Bodoni 72 Oldstyle",
						"Bodoni 72 Smallcaps",
						"Bradley Hand",
						"Brush Script MT",
						"Chalkboard",
						"Chalkboard SE",
						"Chalkduster",
						"Charter",
						"Cochin",
						"Comic Sans MS",
						"Copperplate",
						"Courier",
						"Courier New",
						"Didot",
						"DIN Alternate",
						"DIN Condensed",
						"Futura",
						"Geneva",
						"Georgia",
						"Gill Sans",
						"Helvetica",
						"Helvetica Neue",
						"Herculanum",
						"Hoefler Text",
						"Impact",
						"Lucida Grande",
						"Luminari",
						"Marker Felt",
						"Menlo",
						"Microsoft Sans Serif",
						"Monaco",
						"Noteworthy",
						"Optima",
						"Palatino",
						"Papyrus",
						"Phosphate",
						"Rockwell",
						"Savoye LET",
						"SignPainter",
						"Skia",
						"Snell Roundhand",
						"Tahoma",
						"Times",
						"Times New Roman",
						"Trattatello",
						"Trebuchet MS",
						"Verdana",
						"Zapfino",
					].sort()
				);

				await window.document.fonts.ready;

				const fontAvailable = new Set();

				for (const font of fontCheck.values()) {
					if (window.document.fonts.check(`12px "${font}"`)) {
						fontAvailable.add(font);
					}
				}

				// console.log('Available Fonts:', [...fontAvailable.values()]);

				let { fonts } = window.document;
				const it = fonts.entries();

				let arr = [];
				let done = false;

				while (!done) {
					const font = it.next();
					if (!font.done) {
            if (font.value && font.value[0]) {
              arr.push(font.value[0].family);
            }
					} else {
						done = font.done;
					}
				}
			}

			// converted to set then arr to filter repetitive values
			// console.log([...new Set(arr)]);
		})();
	}, []);

	const getPageZoomBySize = (pageSize = {}) => {
		const { size = "landscape", pageType = "A4" } = pageSize;
		// if (pageType === "A4" && size === "portrait") {
		// 	return "131%";
		// } else if (pageType === "A4" && size === "landscape") {
		// 	return "165%";
		// } else if (pageType === "letter" && size === "portrait") {
		// 	return "131.1%";
		// } else {
		// 	return "160%";
		// }
		if (size === "portrait") {
			return "131%";
		} else {
			return "160%";
		}
  };

  const jwtToken = localStorage.getItem(JWT_TOKEN);
  const isIpwruDomain = host.includes("ipwru.com");

  var orgName = "CTi3";
  if (parsedDoc?.issuer?.name) {
    orgName = parsedDoc.issuer.name;
  }

  if (whitelabel?.verifierImage && whitelabel?.verifierImage.includes("ca-central")) {
    whitelabel.verifierImage = cti3Logo;
  }

	return (
		<SnackbarProvider
			maxSnack={3}
			ref={notistackRef}
			id="snack-bar"
			action={(key) => (
				<Button onClick={onClickDismiss(key)} buttonTransparent buttonStyle={{ backgroundColor: "transparent", border: "none" }}>
					<CloseIcon style={{ color: "white" }} />
				</Button>
			)}>
			<div className="new-verifier">
				<VerifierBody theme={verifierTheme}>
					<style>
						{`
							html {
								line-height: 1.15;
							}
							body {
								margin: 0;
							}
							.new-verifier *{
								font-family: "Roboto", "Plus Jakarta Sans","Source Sans Pro","Lato","Times New Roman";
							}
							@media print {
								@page {size: ${printPageSize.pageType} ${printPageSize.size}; margin: none; }
								html, body {
									zoom: ${printPageSize.type === "fabric" ? getPageZoomBySize(printPageSize) : "120%"};
									display: ${printPageSize.type === "fabric" ? "flex" : "block"};
									flex-direction: column;
									align-items: center;
									justify-content: center;
									width: 100%;
									height: 100%;
								}
							}
						`}
					</style>
					<Header>
						<HeaderContainer>
							<HeaderSubContainer>
                <a href={getObjectValue(parsedDoc.issuer, "url", "https://cti3.com")} target="_blank" rel="noreferrer">
                  {!whitelabel?.verifierImage ? <HeaderLogo alt="CTi3" src={isIpwruDomain ? ipwruLogo : cti3Logo} /> : null}
                  {whitelabel?.verifierImage ? <HeaderLogo src={whitelabel.verifierImage} alt={orgName} whitelabeled /> : null}
								</a>
							</HeaderSubContainer>
							<HeaderSubContainer>
								{additionalDataMain?.settings?.verifierConfiguration?.hideHeaderLinks ? null : (
									<HeaderButtonGroup>
                    {/* <LinkButton opacity={0.54} href="https://cti3.com" target="_blank">
											Meet C.TI
										</LinkButton> */}
                    {jwtToken === null ? ( 
                      <LinkButton color={verifierTheme.fontColor1} href={whitelabel?.walletUrl || APP_URL} target="_blank">
											Login
                      </LinkButton>
                    ) : null
                    }
										{/* <LinkButton color={verifierTheme.primaryColor} opacity={verifierTheme.primaryColorOpacity} href="https://bit.ly/try-cti" target="_blank">
											Sign Up
										</LinkButton> */}
									</HeaderButtonGroup>
								)}
							</HeaderSubContainer>
						</HeaderContainer>
					</Header>
					{certState === "loading" ? (
						<SpinnerBox>
							<Spinner theme={{ ...verifierTheme, ...(host.includes("credential.safeguardingcertificate.com") ? { primaryColor: "#FFB300" } : {}) }} />
						</SpinnerBox>
					) : certState === "error" ? (
						<SpinnerBox isError={true}>
							<ErrorPage />
						</SpinnerBox>
					) : (
						<>
							<PrimaryContent>
								<MainContent
									theme={verifierTheme}
									requestedDoc={requestedDoc}
									setRequestedDoc={setRequestedDoc}
									showContainer={showContainer}
									setShowContainer={setShowContainer}
									certState={certState}
									parsedDoc={parsedDoc}
									setParsedDoc={setParsedDoc}
									additionalDataMain={additionalDataMain}
									setAdditionalDataMain={setAdditionalDataMain}
									preview={preview}
									whitelabel={whitelabel}
									creExpired={creExpired}
									printPageSize={printPageSize}
									setPrintPageSize={setPrintPageSize}
									isSmallDevice={isSmallDevice}
									verification={verification}
									renderConfig={renderConfig}
									usedNewApi={usedNewApi}
                  fallbackBackgroundImg={fallbackBackgroundImgRef.current}
								/>
							</PrimaryContent>
							<SecondaryContent>
								<CertContentRight theme={verifierTheme} requestedDoc={requestedDoc} certState={certState} parsedDoc={parsedDoc} additionalDataMain={additionalDataMain} credExpired={creExpired} />
							</SecondaryContent>
						</>
					)}

          <Footer theme={verifierTheme} justifyContent={additionalDataMain?.settings?.verifierConfiguration?.footerContentJustify || "space-between"}>
            <SubFooter1>{whitelabel?.verifierFooterImage ? <img src={whitelabel.verifierFooterImage} style={{ width: "200px" }} alt="organization" /> : <img src={cti3LogoWhite} style={{ width: "140px", marginTop: "-5px" }} alt="CTi3 logo" />}</SubFooter1>
						{additionalDataMain?.settings?.verifierConfiguration?.hideFooterLinks ? null : (
							<FooterButtonGroup theme={verifierTheme}>
								{/*<LinkButton href="https://form.jotform.com/223064424033444" target="_blank">*/}
								{/*	Sign up for C.TI*/}
								{/*</LinkButton>*/}
								{/*<LinkButton href="https://share.hsforms.com/1mE_Div45TBiLxKaQOE7W3A501al" target="_blank">*/}
								{/*	Recommend C.TI*/}
								{/*</LinkButton>*/}
								{/*<LinkButton href="https://www.youtube.com/watch?v=71q2ru4RZXs" target="_blank">*/}
								{/*	Meet C.TI*/}
								{/*</LinkButton>*/}
								<LinkButton href="mailto:contact@cti3.com" target="_blank">
									Contact Support
								</LinkButton>
								<LinkButton href="https://cti3.com" target="_blank">
									About CTi3
								</LinkButton>
                {/* <LinkButton href={APP_URL} target="_blank">
									Login to CTi3
								</LinkButton> */}
							</FooterButtonGroup>
						)}
					</Footer>
				</VerifierBody>
			</div>
		</SnackbarProvider>
	);
}
